// fields to sort by via the API
export const NAME = 'display_name';
export const ROLE = 'role';
